export enum PrinterStatusEnum {
    Deleted,
    Available,
    Rented,
    Damaged
}
